import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { format } from 'date-fns';
import { localeMap } from '../../models/locale.interface';

@Pipe({
  name: 'formatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);


  transform(date: string | number | Date, dateFormat?: string) {
    return format(new Date(date), dateFormat || 'yy.MM.dd HH:mm', {
      locale: localeMap[this.locale],
    });
  }
}
